<ngx-file-drop
  showBrowseBtn="true"
  customBtnStyling="browse-btn"
  browseBtnLabel="Click or Drop to upload"
  (click)="checkIsValid($event)"
  (onFileDrop)="dropped($event)">
</ngx-file-drop>

